import {HTTP} from "@/http";

class EntraRegistrationServiceClass {
  basePath = 'api/v2/entra-registrations';

  /**
   * Get the one Entra app registration.
   * @returns {Promise<Object>}
   */
  getDefault() {
    return HTTP.get(`${this.basePath}/default`);
  }

  /**
   * Create the Entra app registration.
   * @param {Object} registration { appId, clientSecret }
   * @returns {Promise<Object>}
   */
  create(registration) {
    return HTTP.post(this.basePath, registration);
  }

  /**
   * Update the Entra app registration.
   * Only super-admins can edit
   * @param {Object} registration Registration object including its id { id, appId, clientSecret }
   * @returns {Promise<Object>}
   */
  patch(registration) {
    return HTTP.patch(`${this.basePath}/${registration.id}`, registration);
  }
}

/**
 * @type {EntraRegistrationServiceClass}
 */
export const entraRegistrationService = new EntraRegistrationServiceClass();
